<ng-template #statWidgets>
  <div class="stat-content w-100">

    <ng-template #loadingBlock>
      <div class="d-flex justify-content-center mt-4">
        <p class="fw-medium text-muted text-center mb-4"><i>Loading...</i></p>
      </div>
    </ng-template>

    <ng-template #noDataBlock>
      <div class="d-flex justify-content-center mt-4">
        <p class="fw-medium text-muted text-center mb-4"><i>No available data</i></p>
      </div>
    </ng-template>

    <div class="row g-3 justify-content-center" [ngClass]="rowColsClass">

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByManufacturer)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByManufacturerChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by Manufacturer
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByManufacturerChart.chart"
              class="apex-charts"
              [colors]="devicesByManufacturerChart.colors"
              [dataLabels]="devicesByManufacturerChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByManufacturerChart.labels"
              [legend]="devicesByManufacturerChart.legend"
              [series]="devicesByManufacturerChart.series"
              [stroke]="devicesByManufacturerChart.stroke"
              [tooltip]="devicesByManufacturerChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByManufacturerChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByManufacturerChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByManufacturerChart)"
                   (click)="onLegendClick(devicesByManufacturerChart, devicesByManufacturerChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByManufacturerChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByManufacturerChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByManufacturerChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByManufacturerChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByManufacturerChart)">
                {{ isLegendShowingAll(devicesByManufacturerChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by Manufacturer
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByOperatingSystem)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByOperatingSystemChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by OS
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByOperatingSystemChart.chart"
              class="apex-charts"
              [colors]="devicesByOperatingSystemChart.colors"
              [dataLabels]="devicesByOperatingSystemChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByOperatingSystemChart.labels"
              [legend]="devicesByOperatingSystemChart.legend"
              [series]="devicesByOperatingSystemChart.series"
              [stroke]="devicesByOperatingSystemChart.stroke"
              [tooltip]="devicesByOperatingSystemChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByOperatingSystemChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByOperatingSystemChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByOperatingSystemChart)"
                   (click)="onLegendClick(devicesByOperatingSystemChart, devicesByOperatingSystemChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByOperatingSystemChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByOperatingSystemChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByOperatingSystemChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByOperatingSystemChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByOperatingSystemChart)">
                {{ isLegendShowingAll(devicesByOperatingSystemChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by OS
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByOperatingSystemCompliant_Intune)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByOperatingSystemCompliant_IntuneChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by OS (MDM Compliance)
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByOperatingSystemCompliant_IntuneChart.chart"
              class="apex-charts"
              [colors]="devicesByOperatingSystemCompliant_IntuneChart.colors"
              [dataLabels]="devicesByOperatingSystemCompliant_IntuneChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByOperatingSystemCompliant_IntuneChart.labels"
              [legend]="devicesByOperatingSystemCompliant_IntuneChart.legend"
              [series]="devicesByOperatingSystemCompliant_IntuneChart.series"
              [stroke]="devicesByOperatingSystemCompliant_IntuneChart.stroke"
              [tooltip]="devicesByOperatingSystemCompliant_IntuneChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByOperatingSystemCompliant_IntuneChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByOperatingSystemCompliant_IntuneChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByOperatingSystemCompliant_IntuneChart)"
                   (click)="onLegendClick(devicesByOperatingSystemCompliant_IntuneChart, devicesByOperatingSystemCompliant_IntuneChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByOperatingSystemCompliant_IntuneChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByOperatingSystemCompliant_IntuneChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByOperatingSystemCompliant_IntuneChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByOperatingSystemCompliant_IntuneChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByOperatingSystemCompliant_IntuneChart)">
                {{ isLegendShowingAll(devicesByOperatingSystemCompliant_IntuneChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices by OS (MDM Compliance)
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col" [class.d-none]="isOtherClass">

        @if(isChartLoading(chartTitles.devicesByOperatingSystemCompliant_Ours)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByOperatingSystemCompliant_OursChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Compliance vs Latest Major OS
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByOperatingSystemCompliant_OursChart.chart"
              class="apex-charts"
              [colors]="devicesByOperatingSystemCompliant_OursChart.colors"
              [dataLabels]="devicesByOperatingSystemCompliant_OursChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByOperatingSystemCompliant_OursChart.labels"
              [legend]="devicesByOperatingSystemCompliant_OursChart.legend"
              [series]="devicesByOperatingSystemCompliant_OursChart.series"
              [stroke]="devicesByOperatingSystemCompliant_OursChart.stroke"
              [tooltip]="devicesByOperatingSystemCompliant_OursChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByOperatingSystemCompliant_OursChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByOperatingSystemCompliant_OursChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByOperatingSystemCompliant_OursChart)"
                   (click)="onLegendClick(devicesByOperatingSystemCompliant_OursChart, devicesByOperatingSystemCompliant_OursChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByOperatingSystemCompliant_OursChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByOperatingSystemCompliant_OursChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByOperatingSystemCompliant_OursChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByOperatingSystemCompliant_OursChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByOperatingSystemCompliant_OursChart)">
                {{ isLegendShowingAll(devicesByOperatingSystemCompliant_OursChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Compliance vs Latest Major OS
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col" [class.d-none]="isOtherClass">

        @if(isChartLoading(chartTitles.devicesByOperatingSystemCompliant_OursMinor)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByOperatingSystemCompliant_OursMinorChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Compliance vs Latest Minor OS
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByOperatingSystemCompliant_OursMinorChart.chart"
              class="apex-charts"
              [colors]="devicesByOperatingSystemCompliant_OursMinorChart.colors"
              [dataLabels]="devicesByOperatingSystemCompliant_OursMinorChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByOperatingSystemCompliant_OursMinorChart.labels"
              [legend]="devicesByOperatingSystemCompliant_OursMinorChart.legend"
              [series]="devicesByOperatingSystemCompliant_OursMinorChart.series"
              [stroke]="devicesByOperatingSystemCompliant_OursMinorChart.stroke"
              [tooltip]="devicesByOperatingSystemCompliant_OursMinorChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByOperatingSystemCompliant_OursMinorChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByOperatingSystemCompliant_OursMinorChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByOperatingSystemCompliant_OursMinorChart)"
                   (click)="onLegendClick(devicesByOperatingSystemCompliant_OursMinorChart, devicesByOperatingSystemCompliant_OursMinorChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByOperatingSystemCompliant_OursMinorChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByOperatingSystemCompliant_OursMinorChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByOperatingSystemCompliant_OursMinorChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByOperatingSystemCompliant_OursMinorChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByOperatingSystemCompliant_OursMinorChart)">
                {{ isLegendShowingAll(devicesByOperatingSystemCompliant_OursMinorChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Compliance vs Latest Minor OS
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByManagementState)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByManagementStateChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Management State
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByManagementStateChart.chart"
              class="apex-charts"
              [colors]="devicesByManagementStateChart.colors"
              [dataLabels]="devicesByManagementStateChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByManagementStateChart.labels"
              [legend]="devicesByManagementStateChart.legend"
              [series]="devicesByManagementStateChart.series"
              [stroke]="devicesByManagementStateChart.stroke"
              [tooltip]="devicesByManagementStateChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let i of getLegendDisplayIndices(devicesByManagementStateChart); trackBy: trackLegendIndex"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByManagementStateChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByManagementStateChart)"
                   (click)="onLegendClick(devicesByManagementStateChart, devicesByManagementStateChart.legendItems[i].rawLabel)"
              >

                <span class="ss-legend-dot" [style.background]="devicesByManagementStateChart.legendItems[i].color"></span>
                <span class="ss-legend-text">{{devicesByManagementStateChart.legendItems[i].label}}</span>
              </div>
              <div class="ss-legend-item" *ngIf="getOtherLegendItem(devicesByManagementStateChart) as other">
                <span class="ss-legend-dot" style="background: #adb5bd;"></span>
                <span class="ss-legend-text">{{other.label}}</span>
              </div>
            </div>
            <div class="text-center mt-1" *ngIf="isLegendCollapsible(devicesByManagementStateChart)">
              <button type="button" class="btn btn-sm btn-link p-0"
                      (click)="toggleLegendShowAll(devicesByManagementStateChart)">
                {{ isLegendShowingAll(devicesByManagementStateChart) ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Management State
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded">
          <div class="row">
            <div class="col-12">
              <div
                class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                role="alert"
              >
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <strong>{{containerTitle}}</strong>
                  <span *ngIf="previousSync && syncInfoText" class="text-muted" style="font-size: 0.85em;">- {{syncInfoText}}</span>
                </div>

                <div class="d-flex align-items-center" style="gap: 6px;">
                  @if (userDomains) {
                    <span class="badge bg-success-subtle text-success fs-11 d-inline-flex align-items-center gap-1">
                      <i class="ri-filter-3-line"></i>
                      Filtered to {{ userDomainsText }}
                      <button class="btn btn-link btn-sm p-0 ms-1 text-primary lh-1" title="Clear the user domain filter" type="button" (click)="userDomainsClear.emit()"><i class="ri-close-line"></i></button>
                    </span>
                  }
                  <button *ngIf="actionButton0Show"
                    type="button"
                    class="btn btn-sm btn-outline-primary rounded-pill"
                    (click)="actionButton0OnClick()"
                  >
                    {{actionButton0Text}}
                  </button>
                  
                  <span
                    *ngIf="!expandContainer && showTitleHintText"
                    class="text-muted"
                    style="font-size: 0.85em;"
                  >
                    Widget Row
                  </span>
                  <i class="fs-5"
                     [attr.data-bs-toggle]="'tooltip'"
                     [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     [attr.data-bs-toggle]="'tooltip'"
                     data-bs-title="Close"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>
  
          @if (expandContainer) {
            <div class="row mb-1">
              <div class="col-12">
                <div class="w-100">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
